export const Status = [
  'SaisieAdherent',
  'EnCoursDeTransmission',
  'SaisiePrestataire',
  'AReprendreAdherent',
  'RefusAdherent',
  'RepriseAdherent',
] as const

export type Statut = (typeof Status)[number]

export const StatutLibelle: Record<Statut, string> = {
  SaisieAdherent: 'En cours de saisie adhérent',
  EnCoursDeTransmission: 'En cours de transmission',
  SaisiePrestataire: 'En cours de saisie prestataire',
  AReprendreAdherent: "A reprendre par l'adhérent",
  RefusAdherent: "Refusé par l'adhérent",
  RepriseAdherent: "Reprise de la pré-saisie par l'adhérent",
}

export const StatutBadgeType: Record<Statut, string> = {
  SaisieAdherent: 'info',
  EnCoursDeTransmission: 'success',
  SaisiePrestataire: 'info',
  AReprendreAdherent: 'default',
  RefusAdherent: 'error',
  RepriseAdherent: 'info',
}

export type StatutAdherent = Extract<Statut, 'SaisieAdherent' | 'EnCoursDeTransmission' | 'AReprendreAdherent' | 'RepriseAdherent'>
export type StatutPrestataire = Extract<Statut, 'EnCoursDeTransmission' | 'SaisiePrestataire' | 'AReprendreAdherent' | 'RefusAdherent' | 'RepriseAdherent'>

export const StatutAdherentLibelle: Record<StatutAdherent, string> = {
  SaisieAdherent: StatutLibelle.SaisieAdherent,
  EnCoursDeTransmission: StatutLibelle.EnCoursDeTransmission,
  AReprendreAdherent: StatutLibelle.AReprendreAdherent,
  RepriseAdherent: StatutLibelle.RepriseAdherent,
}

export const StatutPrestataireLibelle: Record<StatutPrestataire, string> = {
  EnCoursDeTransmission: StatutLibelle.EnCoursDeTransmission,
  SaisiePrestataire: StatutLibelle.SaisiePrestataire,
  AReprendreAdherent: StatutLibelle.AReprendreAdherent,
  RefusAdherent: StatutLibelle.RefusAdherent,
  RepriseAdherent: StatutLibelle.RepriseAdherent,
}
